import { render } from "./MyRecipes.vue?vue&type=template&id=65fb14c8&scoped=true"
import script from "./MyRecipes.vue?vue&type=script&lang=js"
export * from "./MyRecipes.vue?vue&type=script&lang=js"

import "./MyRecipes.vue?vue&type=style&index=0&id=65fb14c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fb14c8"]])

export default __exports__